const initialClientPathState = {
  clientPath : false
}

export const ClientPathReducer = (state = initialClientPathState, action = {}) => {
    switch (action.type) {
        case 'persist/REHYDRATE':
           return action.payload ? action.payload.ClientPathReducer ? action.payload.ClientPathReducer : state : state;
        case 'CLIENTPATH':
            return {
              ...state,
              clientPath: action.thisClientPath
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/ClientPathReducer.js